export default __webpack_public_path__ + "static/media/logo-chicko-chicken.b7f5686a.png";